import { DashboardFilter, Period } from '../../services/types/Dashboard';

class DashboardSession {
  currentFilter: DashboardFilter;

  saveFilter = (filter: DashboardFilter) => {
    this.currentFilter = filter;
  };

  constructor() {
    this.currentFilter = {
      phase: null,
      period: Period.Week,
      ganttMode: true,
      periodRelative: 0,
      memberUserId: 0,
      pageSize: 10,
      pageNumber: 1,
      sortDescending: false,
      sortField: 'DueDate',
    };
  }
}

export default DashboardSession;
